<template>
  <div class="welfareDetail" id="welfareDetail">
    <pageHeader title="福利详情" />
    <div class="container">
      <h1 class="welfare-title">
        {{ waterInfo.title }}
      </h1>
      <span class="time"
        >有效期：{{ waterInfo.startDate }}至{{ waterInfo.endTime }}</span
      >
      <p class="welfare-detail" v-html="waterInfo.detail"></p>
    </div>
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
export default {
  components: {
    pageHeader,
  },
  data() {
    return {
      waterInfo: {},
    };
  },
  mounted() {
    this.waterInfo = JSON.parse(this.$route.query.welfareInfo);
  },
};
</script>
<style lang="scss">
#welfareDetail {
  strong {
    font-weight: 600;
    font-size: 32px;
    color: #000000;
  }
  p {
    font-weight: 400;
    font-size: 32px;
    line-height: 42px;
    color: #000000;
  }
}

</style>
<style lang="scss" scoped>
.welfareDetail {
  .container {
    padding: 50px 30px;
    .welfare-title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 40px;
      color: #000000;
      line-height: 56px;
      margin-bottom: 20px;
    }
    .time {
      display: block;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 24px;
      color: #bbbbbb;
      line-height: 33px;
      margin-bottom: 60px;
    }
    .welfare-detail {
    //   p {
    //     font-weight: 400;
    //     font-size: 26px;
    //     color: #000000;

    //     strong {
    //       font-weight: 600;
    //       font-size: 32px;
    //       color: #000000;
    //     }
    //   }
    }
    
  }
  
}
</style>


// WEBPACK FOOTER //
// src/views/welfareDetail/index.vue